import { useQuery } from '@tanstack/react-query';
import { auditLogApi } from '../api/auditLogApi';

/**
 * GET /api/eraf/audit-logs/{id} — 감사 로그 상세
 * queryKey: ['audit-log', 'detail', id]
 */
export function useAuditLogDetail(id: number | null) {
  return useQuery({
    queryKey: ['audit-log', 'detail', id],
    queryFn: () => auditLogApi.get(id!),
    enabled: id !== null,
    staleTime: 60_000,
  });
}
